<template>
  <div class="page-auth-login">
    <SectionsPageBanner heading="Register" :min-height="240" />
    <AuthRegister />
  </div>
</template>

<script lang="ts" setup>
/**
 * Define page meta
 */
definePageMeta({
  authType: 'guest',
});

// DATA Definitions
//----------------------------------------------------------------------------------------------------------------------
const route = useRoute();

/**
 * @_HEAD Hook
 */
useHead({
  meta: [
    {
      name: 'canonical',
      content: 'https://www.newhomes.co.nz' + route.fullPath,
    },
  ],
});

const title = 'Register | New Homes - Begin Your New Home Search Journey';
const description = 'Sign up with New Homes, New Zealand\'s leading home builders and development areas. Begin your home buying journey today.';
useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
  twitterCard: 'summary_large_image',
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: 'https://store.newhomeshub.co.nz/static-assets/new-homes-og-image-v2.jpg',
});
</script>
